import BlueButton from '../../components/blue-button';
import PromotionsUtil from '../../../utils/promotions';
import ModalsLib from '../../../lib/modals';

export default () => {
    return (
        <div className="modal animate__animated animate__fadeInUp animate__faster promotion-modal promotion-facebook">
            <div className="modal-header">
                <div className="close" onClick={e => {
                    PromotionsUtil.closePromotionModal('promotions-facebook');
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="layer">
                    <div className="facebook-icon"></div>
                </div>
                <div className="layer">
                    <div className="content center">
                        <div className="top">
                            <div className="title">FACEBOOK<br/><span>BOOST</span></div>
                            <div className="descriptions">Complete daily tasks and receive <b>daily free $5</b>, as well as other bonuses.</div>
                        </div>
                        <div className="center">
                            <div className="facebook-ticket">

                            </div>
                        </div>
                        <div className="bottom">
                            <BlueButton onClick={e => {
                                PromotionsUtil.clickPromotionModals('promotions-facebook', () => {
                                    ModalsLib.open('facebook');
                                });
                            }}>More info</BlueButton>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    )
}